// Core packages
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";

// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { ActivationsService } from "src/app/modules/settings/activations.service";
import { ActivationEditDialogComponent } from 'src/app/modules/settings/components/activation-edit-dialog/activation-edit-dialog.component';
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";

/**
 * Script start
 */
@Component({
  selector: "app-activation-list-dialog",
  templateUrl: "./activation-list-dialog.component.html",
  styleUrls: ["./activation-list-dialog.component.scss"],
})
export class ActivationListDialogComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  dialogIsLoading = true; // Used to view/hide form loading spinner
  title = "";

  activations: any[] = [];

  activationItems: any[] = [];
  documentTemplateId = "";
  documentTemplate: any[] = [];

  fieldGroup: any[] = [];

  // BEGIN - Edit item form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  subForm: FormGroup = new FormGroup({});
  newSubForm: FormGroup = new FormGroup({});
  model: any = {};
  subModel: any = {};
  newSubModel: any = {};
  fields: FormlyFieldConfig[] = [];
  subFields: FormlyFieldConfig[] = [];
  newSubFields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  subOptions: FormlyFormOptions = {};
  newSubOptions: FormlyFormOptions = {};

  // END - ngx-formly
  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.save"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true,
    },
  };

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<ActivationListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private configService: ConfigService,
    private translateService: TranslateService,
    private authService: AuthService,
    private cookieService: CookieService,
    private toastrService: ToastrService,
    private helperService: HelperService,
    private settingsService: SettingsService,
    private activationsService: ActivationsService
  ) { }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {

    if (
      this.data.item &&
      this.data.item.formConfig &&
      Array.isArray(this.data.item.formConfig) &&
      this.data.item.formConfig.length === 1 &&
      this.data.item.formConfig[0].fieldGroup &&
      Array.isArray(this.data.item.formConfig[0].fieldGroup)
    ) {
      this.title = this.data.item.translation.it;
      this.fieldGroup = this.data.item.formConfig[0].fieldGroup;
    }

    this.getSectionActivations();
  }

  /**
   * Get activation of section: es "anagrafica"
   */
  getSectionActivations(): void {
    this.activations = [];
    this.activationItems = [];
    this.documentTemplateId = "";
    this.documentTemplate = [];

    this.subscriptions.push(
      this.settingsService.getDocument().subscribe(
        (res) => {
          if (res.status) {
            if (
              res.data &&
              Array.isArray(res.data) &&
              res.data.length > 0 &&
              res.data[0].area &&
              Array.isArray(res.data[0].area)
            ) {
              this.documentTemplateId = res.data[0]._id;
              this.documentTemplate = res.data[0].area;
            }
          }

          const key = this.data.item.key;
          if (this.data && this.data.item && this.data.item.key) {
            this.subscriptions.push(
              this.activationsService.getList(0, 100, 'structure', 'desc', { 'structure': this.data.item.key })
                .subscribe(
                  (res) => {
                    if (res.status) {
                      this.activations = res.data.items;

                      if (this.activations && Array.isArray(res.data.items)) {
                        this.activations.forEach((item: any) => {
                          let fields = '';
                          let docs = '';
                          let fireActivation = '';
                          let nameDocs = '';
                          if (item.fields && Array.isArray(item.fields)) {
                            item.fields.forEach((field: any) => {
                              const index = this.fieldGroup.findIndex((el: any) => el.key === field.name);
                              if (index > -1) {
                                if (
                                  this.fieldGroup[index].templateOptions &&
                                  this.fieldGroup[index].templateOptions.translationLabel &&
                                  this.fieldGroup[index].templateOptions.translationLabel.it
                                ) {
                                  let value = field.value;
                                  if (
                                    this.fieldGroup[index].templateOptions.options &&
                                    Array.isArray(this.fieldGroup[index].templateOptions.options)
                                  ) {
                                    const subIndex = this.fieldGroup[index].templateOptions.options.findIndex((subEl: any) => subEl.value === value);
                                    if (
                                      subIndex > -1 &&
                                      this.fieldGroup[index].templateOptions.options[subIndex].translation &&
                                      this.fieldGroup[index].templateOptions.options[subIndex].translation.it
                                    ) {
                                      value = this.fieldGroup[index].templateOptions.options[subIndex].translation.it;
                                    }
                                  }
                                  fields = `${fields}${this.fieldGroup[index].templateOptions.translationLabel.it} ${field.operation} ${value}<br>`;
                                }
                              }
                            });
                          }
                          if (item.docs && Array.isArray(item.docs)) {
                            item.docs.forEach((doc: any) => {
                              // if (doc.key && Array.isArray(doc.key)) {
                              //   doc.key.forEach((key: any) => {
                              //     nameDocs = `${nameDocs}${key.name} `;
                              //   });
                              // }
                              if (doc.activationType && doc.activationType !== '') {
                                fireActivation = ` (${doc.activationType})`;
                              }

                              let docName = doc.name;
                              let found = false;
                              if (
                                this.documentTemplate &&
                                Array.isArray(this.documentTemplate)
                              ) {
                                for (const docsTemplate of this.documentTemplate) {
                                  const content = docsTemplate.content;
                                  if (content && Array.isArray(content)) {

                                    for (const subDocs of content) {
                                      const title = subDocs.title.replace('properties.documents.', '');
                                      if (title === doc.name) {
                                        found = true;
                                        docName = subDocs.translation.it;
                                        doc.translation = subDocs.translation;

                                        const documents = subDocs.documents;
                                        if (documents && Array.isArray(documents)) {
                                          nameDocs = '';
                                          if (doc.keys && Array.isArray(doc.keys)) {
                                            doc.keys.forEach((key: any) => {
                                              const docIndex = documents.findIndex((el: any) => el.key === key);
                                              if (docIndex > -1) {
                                                nameDocs = `${nameDocs} - ${documents[docIndex].translation.it}<br>`;
                                                // key.translation = documents[docIndex].translation;
                                              }
                                            });
                                          }

                                        }
                                      }

                                      if (found) {
                                        break;
                                      }
                                    }
                                  }
                                  if (found) {
                                    break;
                                  }
                                }
                              }

                              docs = `${docs}${docName}${fireActivation}: <br> ${nameDocs}`;
                            });
                          }

                          this.activationItems.push({
                            id: item._id,
                            fields,
                            docs,
                          });
                        });
                      }
                    }
                    this.dialogIsLoading = false;
                  },
                  (err) => {
                    this.helperService.handleError(err);
                    this.dialogIsLoading = false;
                  }
                )
            );
          }

        },
        (err) => {
          this.helperService.handleError(err);
          this.dialogIsLoading = false;
        }
      )
    );
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Handle new activation
   *
   * @since 1.0.0
   */
  onNew(): void {
    const dialogRef = this.dialog.open(ActivationEditDialogComponent, {
      data: {
        new: true,
        structure: this.data.item.title.replace('properties.structures.', ''),
        documentTemplate: this.documentTemplate,
        fieldGroup: this.fieldGroup,
      },
      width: "98%",
    });
    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (res) {
            this.dialogIsLoading = true;
            this.getSectionActivations();
          }
        },
        (err) => {
          this.helperService.handleError(err);
        }
      );
  }

  /**
   * Handle edit activation
   *
   * @since 1.0.0
   */
  onEdit(id: string): void {
    const activations = this.activations.filter((el: any) => el._id.toString() === id.toString());
    const dialogRef = this.dialog.open(ActivationEditDialogComponent, {
      data: {
        new: false,
        structure: this.data.item.title.replace('properties.structures.', ''),
        id,
        activations: Array.isArray(activations) && activations.length ? activations[0]: [],
        documentTemplate: this.documentTemplate,
        fieldGroup: this.fieldGroup,
      },
      width: "98%",
    });
    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (res) {
            this.dialogIsLoading = true;
            this.getSectionActivations();
          }
        },
        (err) => {
          this.helperService.handleError(err);
        }
      );
  }

  /**
   * Handle delete activation
   *
   * @since 1.0.0
   */
  onDelete(id: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translateService.instant('settings.activation.dialog.delete.title'),
        message: this.translateService.instant('settings.activation.dialog.delete.message'),
        btnOkText: this.translateService.instant("common.cta.confirm"),
        btnCancelText: this.translateService.instant('common.cta.close'),
      },
      width: '500px',
      disableClose: true
    });
    // Subscribe to dialog result (only for 1 emit thanks to "take()")
    dialogRef.beforeClosed()
      .pipe(
        take(1)
      )
      .subscribe(
        res => {
          if (res) {
            this.activationsService.delete(id)
              .subscribe(
                (res) => {
                  if (res.status) {
                    this.toastrService.success(res.message);
                    this.dialogIsLoading = true;
                    this.getSectionActivations();
                  }
                },
                (err) => {
                  this.helperService.handleError(err);
                  this.dialogIsLoading = false;
                }
              )
          }
        }
      );
  }

  /**
   * Handle dialog denial
   *
   * @since 1.0.0
   */
  onClose(data?: any): void {
    this.dialogRef.close();
  }
}
